<template>
  <div class="alert" :class="'alert-' + alertClass">
    <span :class="iconClass"></span>
    <div class="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Gs1Alert',
  props: {
    alertClass: {
      type: String,
      default: 'danger'
    },
    iconClass: {
      type: String,
      default: 'fa fa-times-circle color-orange'
    }
  }
}
</script>

<style scoped>
.toolkit .alert {
    padding: 20px;
    margin-bottom: 46px;
}
.toolkit .alert span {
    font-size: 24px;
    float: left;
    margin-top: 1px;
    position: relative;
}
.toolkit .alert .content {
  margin-left: 40px;
}
.toolkit .alert .content p {
  color: var(--gs1-dark-gray);
  font-size: 20px;
  margin: 0;
}
.toolkit .alert .content p.small {
  font-size: 16px;
  margin-top: 6px;
}
@media (max-width: 575.98px) {
  .toolkit .alert {
    margin-left: -15px;
    margin-right: -15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/alerts/Gs1Alert.vue